import { designMode } from '@/env';
import { api } from '@/api';
import router from '@/router';
import { toBoolean } from '@/utils';
import { AxiosError } from 'axios';
import { getStoreAccessors } from 'typesafe-vuex';
import { ActionContext } from 'vuex';
import { State } from '../state';
import { MainState } from '../main/state';
import { IAccountInfo } from '.';
import { dispatchCheckApiError } from '../main/actions';

type UserContext = ActionContext<MainState, State>;

export const actions = {
    async actionGetAccountInfo(context: UserContext) {
        try {
            let data: any;
            if (toBoolean(designMode)) {
                let dummy: IAccountInfo = {
                    company_name: '株式会社 CFOAi',
                    company_url: 'cfo-ai.co.jp',
                    company_foundation_date: new Date(),
                    company_industry_category1: 'パソコン',
                    company_industry_detail1: 'パソコンソフトウェア',
                    company_industry_category2: '素材・化学・エネルギー',
                    company_industry_detail2: '鉄鋼・金属・ガラス・土石・ゴム',
                    company_industry_category3: '',
                    company_industry_detail3: '',
                    company_growth_phase: 'シリーズA：累計調達3億未満',
                    user_last_name: '大谷',
                    user_first_name: '翔太',
                    user_title: '専務取締役',
                    user_email: 'test@gmail.com',
                };
                data = dummy;
            } else {
                const response = await api.getAccountInfo(context.rootState.main.token);
                data = response.data;
            }
            if (data) {
                return data;
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionUpdateAccountInfo(context: UserContext, payload: IAccountInfo) {
        try {
            if (!toBoolean(designMode)) {
                await Promise.all([
                    api.updateAccountInfo(context.rootState.main.token, payload),
                    await new Promise((resolve, reject) => setTimeout(() => resolve(), 500)),
                ]);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
};

const { dispatch } = getStoreAccessors<MainState | any, State>('');

export const dispatchGetAccountInfo = dispatch(actions.actionGetAccountInfo);
export const dispatchUpdateAccountInfo = dispatch(actions.actionUpdateAccountInfo);
